export const getShippingPrice = (shippingFees, orderTotal) => {
  if (!Array.isArray(shippingFees) || shippingFees.length === 0) {
    return null;
  }

  const applicableTiers = shippingFees.filter(
    (tier) => parseFloat(tier.from_order_price) <= orderTotal
  );

  if (applicableTiers.length === 0) {
    return null;
  }

  const applicable = applicableTiers.reduce((highest, tier) =>
    parseFloat(tier.from_order_price) > parseFloat(highest.from_order_price)
      ? tier
      : highest
  );

  return parseFloat(applicable.shipping_price);
};
